import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import { IUnitListBuilder } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/unit_list_builder'; // unit_list_builder
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [],
};

const base = new StoreBaseImplementationV2<IUnitListBuilder>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
